import React, { createContext, useContext, useEffect, useState } from "react";
import services from "../services/services";
const AppContext = createContext();

export const useAppContext = () => {
	return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
	const tenantGroup = sessionStorage.getItem("tenant_group");
	
	// Debug logging
	console.log("tenantGroup:", tenantGroup);
	console.log("localStorage key:", `${tenantGroup}.cookiePreference`);
	console.log("localStorage value:", localStorage.getItem(`${tenantGroup}.cookiePreference`));

	const [showCookiePreferenceModal, setShowCookiePreferenceModal] =
		useState(false);

	// Initialize as false first, then check in useEffect
	const [cookiePreferenceSet, setCookiePreferenceSet] = useState(false);

	// Add ToU state variables
	const [touAccepted, setTouAccepted] = useState(false);

	const [cookiePreference, setCookiePreference] = useState({
		essential: false,
		performance: false,
		functional: false,
		targeting: false,
	});

	const [features, setFeatures] = useState();
	const [loadingFeatures, setLoadingFeatures] = useState(false);

	const fetchFeatures = () => {
		console.log("Fetching features");
		setLoadingFeatures(true);
		services
			.getFeatures()
			.then((response) => {
				console.log(response);
				setFeatures(response);
			})
			.finally(() => {
				setLoadingFeatures(false);
			});
	};

	const saveCookiePreference = (cookiePref) => {
		if (cookiePref) {
			const cookiePrefJSON = JSON.stringify(cookiePref);
			sessionStorage.setItem(`${tenantGroup}.cookiePreference`, cookiePrefJSON);
			setCookiePreferenceSet(true);
			setCookiePreference(cookiePref);
			console.log("Cookie preference saved:", cookiePref);
		}
	};

	// Add ToU save function
	const saveTouAcceptance = (accepted) => {
		if (accepted) {
			sessionStorage.setItem(`${tenantGroup}.touAccepted`, JSON.stringify(accepted));
			setTouAccepted(true);
			console.log("ToU acceptance saved:", accepted);
		}
	};

	useEffect(() => {
		// Only check if tenantGroup exists
		if (tenantGroup) {
			// Check cookie preferences
			const storedCookiePreference = sessionStorage.getItem(
				`${tenantGroup}.cookiePreference`
			);
			
			console.log("Stored cookie preference:", storedCookiePreference);
			
			if (storedCookiePreference) {
				setCookiePreference(JSON.parse(storedCookiePreference));
				setCookiePreferenceSet(true);
				console.log("Cookie preference found - banner will be hidden");
			} else {
				setCookiePreferenceSet(false);
				console.log("No cookie preference found - banner will be shown");
			}

			// Check ToU acceptance
			const storedTouAcceptance = sessionStorage.getItem(
				`${tenantGroup}.touAccepted`
			);
			
			console.log("Stored ToU acceptance:", storedTouAcceptance);
			
			if (storedTouAcceptance) {
				setTouAccepted(JSON.parse(storedTouAcceptance));
				console.log("ToU acceptance found - ToU will be hidden");
			} else {
				setTouAccepted(false);
				console.log("No ToU acceptance found - ToU will be shown after cookies");
			}
		} else {
			// If no tenantGroup, show banner
			setCookiePreferenceSet(false);
			setTouAccepted(false);
			console.log("No tenantGroup - banner and ToU will be shown");
		}

		// fetchFeatures();
	}, [tenantGroup]);

	console.log("cookiePreferenceSet:", cookiePreferenceSet);
	console.log("touAccepted:", touAccepted);

	return (
		<AppContext.Provider
			value={{
				tenantGroup,
				features,
				setFeatures,
				loadingFeatures,
				setLoadingFeatures,
				showCookiePreferenceModal,
				setShowCookiePreferenceModal,
				cookiePreference,
				setCookiePreference,
				saveCookiePreference,
				cookiePreferenceSet,
				setCookiePreferenceSet,
				touAccepted, 
				setTouAccepted, 
				saveTouAcceptance, 
			}}
		>
			{children}
		</AppContext.Provider>
	);
};
